export enum ESocialLinks {
  FACEBOOK = "facebook",
  TIKTOK = "tiktok",
  INSTAGRAM = "instagram",
}
